import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './checkin-search-result.actions';
import { CheckinSearchResultState } from './checkin-search-result.state';

/**
 * checkinSearchResult initial state
 */
export const checkinSearchResultInitialState: CheckinSearchResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for CheckinSearchResult Store
 */
export const checkinSearchResultReducerFeatures: ReducerTypes<CheckinSearchResultState, ActionCreator[]>[] = [
  on(actions.setCheckinSearchResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateCheckinSearchResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetCheckinSearchResult, () => checkinSearchResultInitialState),

  on(actions.cancelCheckinSearchResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failCheckinSearchResult, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setCheckinSearchResultFromApi, actions.updateCheckinSearchResultFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * CheckinSearchResult Store reducer
 */
export const checkinSearchResultReducer = createReducer(
  checkinSearchResultInitialState,
  ...checkinSearchResultReducerFeatures
);
